import { render } from "./DocumentEditor.vue?vue&type=template&id=1bb29b04&scoped=true"
import script from "./DocumentEditor.vue?vue&type=script&lang=js"
export * from "./DocumentEditor.vue?vue&type=script&lang=js"

import "./DocumentEditor.vue?vue&type=style&index=0&id=1bb29b04&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb29b04"]])

export default __exports__